// src/components/assessment/DevToolbar.jsx

import React from 'react';
import { Wrench, FastForward, Brain, CheckCircle2 } from 'lucide-react';

const DevToolbar = ({ setStage, setRadarScores, setAgentContext }) => {
    return (
        <div className="absolute bottom-4 left-4 z-[9999] group opacity-30 hover:opacity-100 transition-opacity">
            <div className="bg-slate-900 text-white p-2 rounded-xl shadow-2xl border border-slate-700 flex flex-col gap-2 items-start">
                <div className="flex items-center gap-2 px-2 text-[10px] font-bold text-yellow-400 uppercase tracking-widest border-b border-white/10 w-full pb-1">
                    <Wrench size={10} /> Dev Override
                </div>
                <div className="grid grid-cols-2 gap-1 w-full">
                    <button onClick={() => setStage('intro')} className="px-2 py-1 bg-white/10 hover:bg-white/20 rounded text-[10px] text-left">1. Intro</button>
                    <button onClick={() => setStage('baseline')} className="px-2 py-1 bg-white/10 hover:bg-white/20 rounded text-[10px] text-left">2. Baseline</button>
                    <button onClick={() => {
                        setRadarScores({ focus: 60, resilience: 60, motivation: 60, confidence: 60, discipline: 60, awareness: 60, adaptability: 60, sleep_perf: 30, nutrition: 60, injury_mgmt: 60 });
                        setStage('radar');
                    }} className="px-2 py-1 bg-white/10 hover:bg-white/20 rounded text-[10px] text-left flex items-center gap-1"><FastForward size={10}/> 3. Radar</button>
                    <button onClick={() => setStage('game')} className="px-2 py-1 bg-white/10 hover:bg-white/20 rounded text-[10px] text-left">4. Game</button>
                    <button onClick={() => {
                        setAgentContext({ mode: 'clinical', targetMetric: 'sleep_perf' });
                        setStage('clinical_active');
                    }} className="px-2 py-1 bg-teal-900/50 text-teal-300 hover:bg-teal-900 rounded text-[10px] text-left flex items-center gap-1 col-span-2 justify-center border border-teal-800"><Brain size={10}/> Jump to Agent</button>
                    <button onClick={() => setStage('complete')} className="px-2 py-1 bg-green-900/50 text-green-300 hover:bg-green-900 rounded text-[10px] text-left flex items-center gap-1 col-span-2 justify-center border border-green-800"><CheckCircle2 size={10}/> Force Complete</button>
                </div>
            </div>
        </div>
    );
};

export default DevToolbar;